import axios from 'axios';
import { supabase } from '../supabase/client';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
});

apiClient.interceptors.request.use(
  async config => {
    const session = await supabase.auth.getSession();
    const token = session?.data?.session?.access_token;

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  error => Promise.reject(error)
);

apiClient.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response.status === 503) {
      return Promise.reject(new Error('Nessuna connessione a internet'));
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const { data, error: refreshError } =
        await supabase.auth.refreshSession();

      if (refreshError) {
        // Handle refresh error (e.g., redirect to login)
        return Promise.reject(refreshError);
      }

      const newToken = data.session.access_token;
      originalRequest.headers['Authorization'] = `Bearer ${newToken}`;

      return apiClient(originalRequest);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
